import { CreateOrganisationType } from 'types/organisations.type';
import { ApiClient } from './interceptor';

const api = ApiClient.getInstance();

export const getOrganizations = async () => {
  return await api.get('organisation');
};

export const getOrganizationsStatistics = async () => {
  return await api.get('organisation/statistics');
};

export const getOrganizationNames = async () => {
  return await api.get('organisation/names');
};

export const searchOrganisations = async (searchTerm: string) => {
  return await api.get(`organisation/lookup/${searchTerm}`);
};


export const searchOrganisationsStatistics = async (searchTerm: string) => {
  return await api.get(`organisation/statistics/lookup/${searchTerm}`);
};

export const getOrganisationById = async (id: string) => {
  return await api.get(`organisation/${id}`);
};

const buildOrganisationFormData = (
  organisation: CreateOrganisationType,
): FormData => {
  const formData = new FormData();

  formData.append('companyName', organisation.companyName);
  formData.append('contactEmail', organisation.contactEmail);
  formData.append('emailHandler', organisation.emailHandler);
  formData.append('address', organisation.address);
  formData.append('isOpen', String(organisation.isOpen));
  formData.append('selfCreateGroups', String(organisation.selfCreateGroups));

  if (organisation.groups?.length) {
    formData.append('groups', JSON.stringify(organisation.groups));
  }

  if (organisation.companyLogo) {
    formData.append('logo', organisation.companyLogo);
  }

  return formData;
};

export const createOrganisation = async (
  organisation: CreateOrganisationType,
) => {
  return await api.post('organisation', buildOrganisationFormData(organisation), {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deleteOrganisation = async (orgId: string) => {
  return await api.delete(`organisation/${orgId}`);
};

export const deleteOrganisationBulk = async (orgIds: string[]) => {
  return await api.deleteWithParams('organisation', { UIds: orgIds });
};

export const modifyOrganisation = async (
  orgId: string,
  organisation: CreateOrganisationType,
) => {
  return await api.put(`organisation/${orgId}`, buildOrganisationFormData(organisation), {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const generatePin = async (orgId: string) => {
  return await api.put(`organisation/${orgId}/regenerate-pin`);
};

export const resetOrganisationScore = async (orgId: string) => {
  return await api.put(`organisation/reset-score/${orgId}`);
};